// extracted by mini-css-extract-plugin
module.exports = {"mlabel":"L11_mlabel__2B__I","minput":"L11_minput__3R_FR","buttonAdd":"L11_buttonAdd__2diUE"};